import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from '@tanstack/react-router'
import { z } from 'zod'
import { hasAbility } from '@/lib/rbac'
import { UsersPage } from '@/components/users/users-page'

const defaultValues = {
  page: 0,
}

export const usersSearchSchema = z.object({
  page: z
    .number()
    .int()
    .min(0)
    .default(defaultValues.page)
    .catch(defaultValues.page),
  cursor: z.string().nullable().optional(),
  q: z.string().optional(),
  history: z.string().optional(),
})

export const Route = createFileRoute('/_auth/_main-layout/users')({
  beforeLoad: () => {
    if (!hasAbility('manage_vixiees_users')) {
      throw redirect({ to: '/accounts' })
    }
  },
  component: UsersPage,
  validateSearch: usersSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
})
